import { NavLink, useNavigate } from "react-router-dom";
import { useAdminAuth } from "./AdminAuth";
import { logout } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { CalendarRange, FileText, Settings, Layers, ScrollText, LogOut, MailQuestion, Image as ImageIcon, GraduationCap } from "lucide-react";

const NAV = [
  { to: "/admin", label: "Calendar", icon: CalendarRange, end: true },
  { to: "/admin/orders", label: "Orders", icon: ScrollText },
  { to: "/admin/blog", label: "Blog", icon: FileText },
  { to: "/admin/pages", label: "Pages CMS", icon: Layers },
  { to: "/admin/media", label: "Media", icon: ImageIcon },
  { to: "/admin/enquiries", label: "Enquiries", icon: MailQuestion },
  { to: "/admin/intensive-offers", label: "Intensive offers", icon: GraduationCap },
  { to: "/admin/settings", label: "Settings", icon: Settings },
];

export default function AdminLayout({ children }) {
  const { user, setUser } = useAdminAuth();
  const navigate = useNavigate();
  const onLogout = async () => {
    try { await logout(); } catch {}
    setUser(null);
    navigate("/admin/login");
  };
  return (
    <div className="min-h-screen bg-[#F3F4F6] text-[#111827]" style={{ fontFamily: "Manrope, system-ui, sans-serif" }} data-testid="admin-layout">
      <header className="bg-[#111827] text-white">
        <div className="max-w-[1600px] mx-auto px-4 h-14 flex items-center justify-between">
          <div className="flex items-center gap-2" data-testid="admin-brand">
            <span className="px-1.5 py-0.5 bg-[#37B160] text-white text-sm font-bold tracking-[0.15em]" style={{fontFamily:"Outfit, sans-serif"}}>LIME</span>
            <span className="text-xs font-medium tracking-[0.2em] text-white/80 hidden sm:inline" style={{fontFamily:"Outfit, sans-serif"}}>DRIVING SCHOOL · ADMIN</span>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-xs text-white/60 hidden sm:inline" data-testid="admin-user-email">{user?.email}</span>
            <Button size="sm" variant="ghost" onClick={onLogout} className="text-white hover:bg-white/10" data-testid="admin-logout-btn"><LogOut className="h-4 w-4 mr-1" /> Sign out</Button>
          </div>
        </div>
      </header>
      <div className="max-w-[1600px] mx-auto px-4 grid grid-cols-1 md:grid-cols-12 gap-6 py-6">
        <aside className="md:col-span-3 lg:col-span-2">
          <nav className="bg-white border border-black/5 rounded-2xl p-2 flex md:flex-col gap-1 overflow-x-auto" data-testid="admin-sidebar">
            {NAV.map(n => (
              <NavLink key={n.to} to={n.to} end={n.end}
                       data-testid={`admin-nav-${n.label.toLowerCase().replace(/\s+/g,'-')}`}
                       className={({isActive}) =>
                         `flex items-center gap-2 px-3 py-2 rounded-xl text-sm transition-colors whitespace-nowrap ${isActive ? 'bg-[#111827] text-white' : 'text-[#4B5563] hover:bg-black/5'}`}>
                <n.icon className="h-4 w-4" /> {n.label}
              </NavLink>
            ))}
          </nav>
        </aside>
        <main className="md:col-span-9 lg:col-span-10 min-w-0">
          {children}
        </main>
      </div>
    </div>
  );
}
